<template>
    <transition name="modal" v-if="visible">
        <div class="custom-modal-mask modal-auth">
            <div class="custom-modal-wrapper">
                <div class="custom-modal-container" v-click-outside="hide">
                    <div style="position: relative">
                        <ul class="nav nav-tabs">
                            <li class="nav-item"><a class="active" data-toggle="tab" href="#login">Đăng nhập</a></li>
                            <li class="nav-item register"><a data-toggle="tab" href="#register">Đăng ký</a></li>
                        </ul>
                        <div class="tab-content">
                            <div id="login" class="tab-pane fade show active">
                                <login></login>
                            </div>
                            <div id="register" class="tab-pane fade">
                                <register></register>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import Login from "../login/Login";
    import Register from "../register/Register";
    import { ModalAuthPlugin } from "../../../plugins";
    export default {
        name: "ModalAuth",
        components: {Register, Login},
        beforeMount() {
            ModalAuthPlugin.EventBus.$on('show', () => {
                this.show();
            });
            ModalAuthPlugin.EventBus.$on('hide', () => {
                this.hide();
            })
        },
        data(){
            return {
                visible: false
            }
        },
        methods: {
            show() {
                this.visible = true;
            },
            hide() {
                this.visible = false;
            }
        }
    }
</script>

<style scoped>

    .modal-auth .custom-modal-container {
        padding: 0 0 15px 0;
        width: 450px;
        border-radius: 5px;
    }

    .modal-auth .nav.nav-tabs li{
        float: left;
        margin-bottom: -1px;
        width: 50%;
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;
        border-radius: 5px 5px 0 0;
    }

    .modal-auth .nav-tabs li a.active {
        color: #333;
        cursor: default;
        background-color: #FFC500;
        /*border: 1px solid #eee;*/
        border-bottom-color: transparent;
        /*border-radius: 5px 5px 0 0;*/
        -webkit-box-shadow: 5px -5px 6px 0px rgba(82,82,82,0.52);
        -moz-box-shadow: 5px -5px 6px 0px rgba(82,82,82,0.52);
        box-shadow: 5px -5px 6px 0px rgba(82,82,82,0.52);
        z-index:1;
        border-radius: 5px;
    }

    .modal-auth .nav-tabs li.register a.active {
        -webkit-box-shadow: -5px -1px 3px 0px rgba(82,82,82,0.52);
        -moz-box-shadow: -5px -1px 3px 0px rgba(82,82,82,0.52);
        box-shadow: -5px -1px 3px 0px rgba(82,82,82,0.52);
    }
    .modal-auth .nav > li > a {
        padding: 17px 25px;
        color: #8C8C8C;
        width: 100%;
        display: block;
        position: relative;
    }

    .modal-auth .nav > li > a:hover {
        text-decoration: none;
    }
    .modal-auth .tab-content {
        padding: 0 25px;
    }

    @media (max-width: 991px) {
        .modal-auth .custom-modal-container {
            width: 80%;
        }
    }
</style>
